import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VehiclePricing } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehiclepricing';
import type { RootState } from '../store';

export const initialState: VehiclePricing = {
  id: 0,
  pricing: {
    price: 0,
    total: 0,
    maintCost: null,
    payments: 0,
    processingFee: 0,
    excessMileCharge: 0,
  },
  initialPayment: {
    default: 0,
    step: 0,
    max: 0,
    min: 0,
  },
};

export const vehiclePriceSlice = createSlice({
  name: 'vehiclePrice',
  initialState: initialState,
  reducers: {
    updatePrice: (state, action: PayloadAction<VehiclePricing>) => {
      state.id = action.payload.id;
      state.pricing = action.payload.pricing;
      state.initialPayment = action.payload.initialPayment;
    },
  },
});

export const { updatePrice } = vehiclePriceSlice.actions;

export const vehiclePrice = (state: RootState) => state.vehiclePrice;

export default vehiclePriceSlice.reducer;
